import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
// import { history } from 'app/history';
import {
  get_Countrycodes,
  get_statusData,
  horoscopeData,
  get_MStatus,
  get_FamilyStatus,
  get_FamilyValue,
  get_FamilyType,
  detailsList
} from './api';

const initialState = {
  loading: false,
  editpartnerdetailsloading: false,
  country_codes: [],
  state_details: [],
  city_details: [],
  family_Status: [],
  family_Value: [],
  family_Type: [],
  education_details: [],
  currency_data: [],
  user_data: []
};

const actions = {
  COUNTRYCODES: 'countryCodes/COUNTRYCODES',
  STATECODES: 'stateCodes/STATECODES',
  CITIES_LIST: 'citieslist/CITIES_LIST',
  CREATEHOROSCOPEDETAILS: 'createhoroscopeDetails/CREATEHOROSCOPEDETAILS',
  FAMILY_STATUS: 'familyStatus/FAMILY_STATUS',
  FAMILY_VALUE: 'familyValue/FAMILY_VALUE',
  FAMILY_TYPE: 'familyType/FAMILY_TYPE',
  EDUCATION_LIST: 'education_list/EDUCATION_LIST',
  Currency_Codes: 'currencyCodes/Currency_Codes',
  EDIT_PARTNERDETAILS: 'editpartnerdetails/EDIT_PARTNERDETAILS',
  GET_BYID: 'get_byID/GET_BYID'
};

export const countryCodes = createAsyncThunk(
  actions.COUNTRYCODES,
  async (payload) => {
    const response = await get_Countrycodes('countries-list', payload);
    return response;
  }
);

// stateCodes/STATECODES
export const stateCodes = createAsyncThunk(
  actions.STATECODES,
  async (payload) => {
    const response = await get_statusData('states-list', payload);
    return response;
  }
);

// cities_list/CITIES_LIST
export const citieslist = createAsyncThunk(
  actions.CITIES_LIST,
  async (payload) => {
    const response = await get_MStatus('cities-list', payload);
    return response;
  }
);

// createhoroscopeDetails/CREATEHOROSCOPEDETAILS
export const createhoroscopeDetails = createAsyncThunk(
  actions.CREATEHOROSCOPEDETAILS,
  async (payload) => {
    const response = await horoscopeData('horoscope', payload);
    return response;
  }
);
// familyStatus/FAMILY_STATUS
export const familyStatus = createAsyncThunk(
  actions.FAMILY_STATUS,
  async (payload) => {
    const response = await get_FamilyStatus('family-status-list', payload);
    return response;
  }
);
// familyValue/FAMILY_VALUE
export const familyValue = createAsyncThunk(
  actions.FAMILY_VALUE,
  async (payload) => {
    const response = await get_FamilyValue('family-values-list', payload);
    return response;
  }
);
// familyType/FAMILY_TYPE
export const familyType = createAsyncThunk(
  actions.FAMILY_TYPE,
  async (payload) => {
    const response = await get_FamilyType('family-types-list', payload);
    return response;
  }
);

// education_list/EDUCATION_LIST
export const education_list = createAsyncThunk(
  actions.EDUCATION_LIST,
  async (payload) => {
    const response = await get_MStatus(
      'higher-education-list?is_qualification=true',
      payload
    );
    return response;
  }
);

// currencyCodes/Currency_Codes
export const currencyCodes = createAsyncThunk(
  actions.Currency_Codes,
  async (payload) => {
    const response = await get_MStatus('currencies-list', payload);
    return response;
  }
);

// editpartnerdetails/EDIT_PARTNERDETAILS
export const editpartnerdetails = createAsyncThunk(
  actions.EDIT_PARTNERDETAILS,
  async (payload) => {
    const response = await horoscopeData('desired-partner', payload);
    return response;
  }
);

export const get_byID = createAsyncThunk(actions.GET_BYID, async (payload) => {
  const response = await detailsList(payload);
  return response;
});

export const EditPartnerDetailsSlice = createSlice({
  name: 'editpartner',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(countryCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(countryCodes.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.country_codes = data;
      })
      .addCase(countryCodes.rejected, (state) => {
        state.loading = false;
      });

    // stateCodes
    builder
      .addCase(stateCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(stateCodes.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.state_details = data;
      })
      .addCase(stateCodes.rejected, (state) => {
        state.loading = false;
      });

    // cities_list
    builder
      .addCase(citieslist.pending, (state) => {
        state.loading = true;
      })
      .addCase(citieslist.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.city_details = data;
      })
      .addCase(citieslist.rejected, (state) => {
        state.loading = false;
      });

    // createhoroscopeDetails
    builder
      .addCase(createhoroscopeDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(createhoroscopeDetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.state_details = data;
      })
      .addCase(createhoroscopeDetails.rejected, (state) => {
        state.loading = false;
      });

    // familyStatus
    builder
      .addCase(familyStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(familyStatus.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.family_Status = data;
      })
      .addCase(familyStatus.rejected, (state) => {
        state.loading = false;
      });

    // familyValue
    builder
      .addCase(familyValue.pending, (state) => {
        state.loading = true;
      })
      .addCase(familyValue.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.family_Value = data;
      })
      .addCase(familyValue.rejected, (state) => {
        state.loading = false;
      });

    // familyType
    builder
      .addCase(familyType.pending, (state) => {
        state.loading = true;
      })
      .addCase(familyType.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.family_Type = data;
      })
      .addCase(familyType.rejected, (state) => {
        state.loading = false;
      });

    // education_list
    builder
      .addCase(education_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(education_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.education_details = data;
      })
      .addCase(education_list.rejected, (state) => {
        state.loading = false;
      });

    // currencyCodes
    builder
      .addCase(currencyCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(currencyCodes.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('slice_currency', data);
        state.loading = false;
        state.currency_data = data;
      })
      .addCase(currencyCodes.rejected, (state) => {
        state.loading = false;
      });

    // editpartnerdetails/EDIT_PARTNERDETAILS
    builder
      .addCase(editpartnerdetails.pending, (state) => {
        state.editpartnerdetailsloading = true;
      })
      .addCase(editpartnerdetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('slice_currency', data);
        state.editpartnerdetailsloading = false;
        state.currency_data = data;
      })
      .addCase(editpartnerdetails.rejected, (state) => {
        state.editpartnerdetailsloading = false;
      });

    builder
      .addCase(get_byID.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(get_byID.fulfilled, (state, action) => {
        const { data } = action.payload;
        console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.user_data = data;

        // console.log('slicelog', data);
      })
      .addCase(get_byID.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });
  }
});

export default EditPartnerDetailsSlice.reducer;
